import CustomButton from 'components/buttons/CustomButton/CustomButton'
import AddIcon from 'icons/AddIcon'
import { useState } from 'react'
import EducationDialog from '../EducationDialog/EducationDialog';
import { IconButton, useMediaQuery, useTheme } from '@mui/material';
import { colors } from 'styles/colors';

export default function AddEducationButton() {
  const [open, setOpen] = useState<boolean>(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      {isMobile ? (
        <IconButton
          onClick={() => setOpen(true)}
          sx={{
            backgroundColor: colors.topBackground,
            width: 35,
            height: 35,
            borderRadius: '4px',
          }}
        >
          <AddIcon
            size={22}
            color={colors.primary}
          />
        </IconButton>
      ) : (
        <CustomButton
          text={`Add Education`}
          height={40}
          fontSize={14}
          startIcon={<AddIcon size={15} />}
          onClick={() => setOpen(true)}
        />
      )}

      <EducationDialog
        open={open}
        setOpen={setOpen}
      />
    </>
  )
}
